module.exports = __webpack_public_path__ + "static/media/selector-arrow-right.d71a7c56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selector-arrow-right.svg
// module id = 477
// module chunks = 0